//import { useGrid } from "common";
import { useParams } from "common/components/Form/ParamsContext";
import { useFilter } from "components/FilterProvider";
import { useMemo } from "react";
import { getScheduleService } from "./scheduleApi";

export type ScheduleFilter = {
  includeExpired?: boolean;
};

export default function useScheduleList() {
  const params = useParams<"boat_id">();
  const [filter, onChange] = useFilter<ScheduleFilter>();
  const scope = { boats: params.boat_id };
  const editUrl = `${
    Object.values(scope || {}).filter(v => !!v).length > 0 ? "schedules/" : ""
  }`;
  const service = getScheduleService(scope);

  const gridFilter = useMemo(() => {
    let f: any = [];

    if (filter?.includeExpired) {
      // Ha be van pipálva, akkor mutassa az összes menetrendet
      // Nincs szűrés a date_to alapján
    } else {
      // Ha nincs bepipálva, akkor csak az aktívakat mutassa (ahol date_to >= mai nap)
      const today = new Date().toISOString().split("T")[0];
      f.push({
        columnField: "date_to",
        operatorValue: "gte",
        value: today,
      });
    }

    return f;
  }, [filter]);

  return { ...service, params, scope, editUrl, filter, onChange, gridFilter };
}
